import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiMessageSquare } from 'react-icons/fi';
import chatService from '../services/chatService';

export default function MessagesBadgeButton({ className = '', pollMs = 30000 }) {
  const [count, setCount] = useState(0);
  const navigate = useNavigate();
  useEffect(() => {
    let mounted = true;
    let timer;
    const load = async () => {
      // Skip polling when not authenticated
      try {
        const token = typeof localStorage !== 'undefined' ? localStorage.getItem('auth:token') : null;
        if (!token) { if (mounted) setCount(0); return; }
      } catch (e) { void e; }
      try {
        const c = await chatService.getUnreadCount();
        if (mounted) setCount(Number(c) || 0);
      } catch (e) { void e; }
    };
    load();
    timer = setInterval(load, pollMs);
    return () => { mounted = false; if (timer) clearInterval(timer); };
  }, [pollMs]);
  return (
    <button
      type="button"
      className={`relative inline-flex items-center justify-center icon-btn w-10 h-10 ${className}`}
      aria-label="Messages"
      onClick={() => navigate('/dashboard/messages')}
      title="Messages"
    >
      <FiMessageSquare className="w-5 h-5" />
      <span className={`absolute -top-1 -right-1 inline-flex items-center justify-center rounded-full text-[10px] px-1.5 py-0.5 ${count > 0 ? 'bg-indigo-600 text-white' : 'bg-subtle-bg text-secondary-text'}`}>
        {count > 0 ? count : 0}
      </span>
    </button>
  );
}
